"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scale = exports.isMobile = exports.isClient = exports.default = exports.IMAGE_DIMENSION_MOBILE_WIDTH = exports.IMAGE_DIMENSION_MOBILE_HEIGHT = exports.IMAGE_DIMENSION_DESKTOP_WIDTH = exports.IMAGE_DIMENSION_DESKTOP_HEIGHT = exports.FEATURED_IMAGE_WIDTH = exports.FEATURED_IMAGE_HEIGHT = exports.FEATURED_IMAGE_FULL_WIDTH = exports.FEATURED_IMAGE_FULL_HEIGHT = exports.EventPill = exports.EventListView = exports.EventListItemView = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _EventDateFormatter = _interopRequireDefault(require("./EventDateFormatter"));

var _EventAttendeesPreview = _interopRequireDefault(require("./EventAttendeesPreview"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Computer = _interopRequireDefault(require("@insided/destination/icons/Computer"));

var _People = _interopRequireDefault(require("@insided/destination/icons/People"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _EventSettings = require("@insided/deprecated-control/Event/event-settings/EventSettings");

var _widgetContainer = require("@insided/deprecated-preact-components/widget-container");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var IMAGE_DIMENSION_DESKTOP_WIDTH = 288;
exports.IMAGE_DIMENSION_DESKTOP_WIDTH = IMAGE_DIMENSION_DESKTOP_WIDTH;
var IMAGE_DIMENSION_DESKTOP_HEIGHT = 128;
exports.IMAGE_DIMENSION_DESKTOP_HEIGHT = IMAGE_DIMENSION_DESKTOP_HEIGHT;
var IMAGE_DIMENSION_MOBILE_WIDTH = 810;
exports.IMAGE_DIMENSION_MOBILE_WIDTH = IMAGE_DIMENSION_MOBILE_WIDTH;
var IMAGE_DIMENSION_MOBILE_HEIGHT = 360;
exports.IMAGE_DIMENSION_MOBILE_HEIGHT = IMAGE_DIMENSION_MOBILE_HEIGHT;
var FEATURED_IMAGE_WIDTH = 1350;
exports.FEATURED_IMAGE_WIDTH = FEATURED_IMAGE_WIDTH;
var FEATURED_IMAGE_HEIGHT = 600;
exports.FEATURED_IMAGE_HEIGHT = FEATURED_IMAGE_HEIGHT;
var FEATURED_IMAGE_FULL_WIDTH = 1200;
exports.FEATURED_IMAGE_FULL_WIDTH = FEATURED_IMAGE_FULL_WIDTH;
var FEATURED_IMAGE_FULL_HEIGHT = 533;
exports.FEATURED_IMAGE_FULL_HEIGHT = FEATURED_IMAGE_FULL_HEIGHT;
var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object';
exports.isClient = isClient;
var scale = isClient && window.devicePixelRatio ? window.devicePixelRatio : 1;
exports.scale = scale;
var isMobile = isClient && (0, _insidedDataStorage.getInsidedData)('device') === 'mobile';
exports.isMobile = isMobile;

var EventListView = function EventListView(_ref) {
  var eventList = _ref.eventList,
      className = _ref.className,
      timeConfig = _ref.timeConfig;
  return (0, _preact.h)("div", {
    className: className
  }, eventList.map(function (event) {
    return (0, _preact.h)(EventListItemView, (0, _extends2.default)({
      key: event.id,
      timeConfig: timeConfig
    }, event, {
      hasWidgetTitle: false,
      hasWidgetSubtitle: false
    }));
  }));
};

exports.EventListView = EventListView;

var EventListItemView = function EventListItemView(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      type = _ref2.type,
      startAt = _ref2.startAt,
      endAt = _ref2.endAt,
      image = _ref2.image,
      location = _ref2.location,
      destinationUrl = _ref2.destinationUrl,
      attendees = _ref2.attendees,
      attendeeCount = _ref2.attendeeCount,
      isLoggedInUserAttendee = _ref2.isLoggedInUserAttendee,
      isFeatured = _ref2.isFeatured,
      isFullWidth = _ref2.isFullWidth,
      timeConfig = _ref2.timeConfig,
      timezoneName = _ref2.timezoneName,
      _ref2$hasWidgetTitle = _ref2.hasWidgetTitle,
      hasWidgetTitle = _ref2$hasWidgetTitle === void 0 ? false : _ref2$hasWidgetTitle,
      _ref2$hasWidgetSubtit = _ref2.hasWidgetSubtitle,
      hasWidgetSubtitle = _ref2$hasWidgetSubtit === void 0 ? false : _ref2$hasWidgetSubtit;

  var _getTimeSettings = (0, _EventSettings.getTimeSettings)(timeConfig, timezoneName),
      hour12 = _getTimeSettings.hour12,
      showTimezone = _getTimeSettings.showTimezone,
      eventTimezone = _getTimeSettings.eventTimezone;

  var formattedStartAt = _EventDateFormatter.default.formatStartAtForOverviewListCustomized(startAt, hour12, showTimezone, eventTimezone);

  var isPastEvent = _EventDateFormatter.default.isPastEvent(endAt);

  var isEventEngagementEnabled = _common.common.isModuleActive('eventEngagement');

  var hrefClassName = "event-list-item__url qa-event-list-item-url qa-event-".concat(id !== null && id !== void 0 ? id : '');
  var imageDimension = isMobile ? "".concat(Math.floor(IMAGE_DIMENSION_MOBILE_WIDTH * scale), "x").concat(Math.floor(IMAGE_DIMENSION_MOBILE_HEIGHT * scale)) : "".concat(Math.floor(IMAGE_DIMENSION_DESKTOP_WIDTH * scale), "x").concat(Math.floor(IMAGE_DIMENSION_DESKTOP_HEIGHT * scale));

  if (image && isFeatured && !isFullWidth && !isMobile) {
    imageDimension = "".concat(FEATURED_IMAGE_WIDTH, "x").concat(FEATURED_IMAGE_HEIGHT);
  }

  if (image && isFeatured && isFullWidth && !isMobile) {
    imageDimension = "".concat(FEATURED_IMAGE_FULL_WIDTH, "x").concat(FEATURED_IMAGE_FULL_HEIGHT);
  }

  var imageUrl = image !== null && image !== void 0 && image.endsWith('.gif') ? image : image === null || image === void 0 ? void 0 : image.split('attachment').join("attachment/".concat(imageDimension));
  var EventTitleTag = (0, _widgetContainer.genericWidgetHeaderTagCalculator)(hasWidgetTitle, hasWidgetSubtitle);

  var parsedTitle = _htmlParser.default.stripHtml(title);

  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(destinationUrl),
    className: hrefClassName,
    "data-track-type": "click",
    "data-element-name": "Event link"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)({
      'featured-event__item': image && isFeatured && !isFullWidth,
      'event-list-item-container': image,
      'topic-view': !isFeatured,
      'event-list-item-details-full-width': !image,
      'card-widget-wrapper': true
    })
  }, image && (0, _preact.h)("div", {
    className: "event-item-image-container"
  }, (0, _preact.h)("div", {
    role: "img",
    "aria-label": title,
    className: "event-item__image",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  })), (0, _preact.h)("div", {
    className: "event-item-detail-container"
  }, type && (0, _preact.h)(EventPill, {
    className: "event-detail-item__type",
    type: type,
    past: isPastEvent
  }), (0, _preact.h)("div", {
    className: (0, _classnames.default)('event-item__date', {
      event__date_past: isPastEvent
    })
  }, formattedStartAt), (0, _preact.h)(EventTitleTag, {
    className: (0, _classnames.default)('h2', 'event-item__title', 'qa-event-title', 'card-widget-title')
  }, parsedTitle), location ? (0, _preact.h)(PeopleLocation, null) : (0, _preact.h)(OnlineLocation, null), (0, _preact.h)(_EventAttendeesPreview.default, {
    isPastEvent: isPastEvent,
    attendeeCount: attendeeCount,
    attendees: attendees,
    isLoggedInUserAttendee: isLoggedInUserAttendee,
    isEventEngagementEnabled: isEventEngagementEnabled
  }))));
};

exports.EventListItemView = EventListItemView;

var EventPill = function EventPill(_ref3) {
  var className = _ref3.className,
      past = _ref3.past,
      type = _ref3.type;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)(className, 'pill', 'pill--uppercase', 'pill--article', 'qa-content-type-pill', {
      'event-pill__past': past
    })
  }, type);
};

exports.EventPill = EventPill;

var OnlineLocation = function OnlineLocation() {
  return (0, _preact.h)("div", {
    className: "event-item__location"
  }, (0, _preact.h)("div", {
    className: "event-item__location_icon"
  }, (0, _preact.h)(_Computer.default, null), ' '), (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "events.location.online",
    m: "Forum"
  })));
};

var PeopleLocation = function PeopleLocation() {
  return (0, _preact.h)("div", {
    className: "event-item__location"
  }, (0, _preact.h)("div", {
    className: "event-item__location_icon"
  }, (0, _preact.h)(_People.default, null), ' '), (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "events.location.in.person",
    m: "Forum"
  })));
};

var _default = EventListView;
exports.default = _default;